import React from 'react';
import LogoResizer from '@gin-betting/components/logo-resizer';
import { GQL } from '@gin-betting/core';
import cn from 'classnames';

import { Icon } from 'components';

import defaultLogo from 'assets/svg/default-logo.svg';
import './teamLogo.scss';

interface Props {
    logoUrl: string | undefined;
    competitorType: GQL.CompetitorType;
    isServer: boolean;
}

const TeamLogo: React.FC<Props> = ({ logoUrl, competitorType, isServer }) => {
    const isPerson = competitorType === GQL.CompetitorType.PERSON;

    return logoUrl ? (
        <LogoResizer url={logoUrl} isOutsource={true}>
            {({ ref, bgImageStyle }) => (
                <div styleName="container" className="__app-TeamLogo-container">
                    <div
                        styleName={cn('logo', {
                            'is-person': isPerson,
                        })}
                        style={bgImageStyle}
                        ref={ref}
                    />
                    {isServer && <div styleName="server" />}
                </div>
            )}
        </LogoResizer>
    ) : (
        <div styleName="container">
            <Icon styleName="icon" glyph={defaultLogo} />
            {isServer && <div styleName="server" />}
        </div>
    );
};

export default TeamLogo;
